import React, { useEffect, useState } from "react";
import { useServerStatus } from "../serverStatus";

const EXPECTED_SECONDS = 50; // typical Render wake-up time, used for the progress bar

const hintFor = (seconds) => {
  if (seconds < 6) return "Connecting…";
  if (seconds < 25) return "Our server was resting and is waking up. This only happens when the site hasn't been used for a while.";
  if (seconds < 60) return "Almost there. Thanks for your patience!";
  return "Taking a little longer than usual. Hang tight. Your details are safe and nothing has been charged.";
};

// Full-screen loader shown only while an applicant's action is waiting on the server.
export default function ServerWakeOverlay() {
  const { status, startedAt, waitingMessage } = useServerStatus();
  const visible = Boolean(waitingMessage) && status === "waking";
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    if (!visible) return;
    const id = setInterval(() => setNow(Date.now()), 500);
    return () => clearInterval(id);
  }, [visible]);

  if (!visible) return null;

  const seconds = Math.max(0, Math.floor((now - (startedAt || now)) / 1000));
  // Eases towards 95% so it never looks "done" before it is.
  const progress = Math.min(95, Math.round(95 * (1 - Math.exp(-seconds / (EXPECTED_SECONDS / 2)))));

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm p-4"
      role="alertdialog"
      aria-live="polite"
      aria-label={waitingMessage}
    >
      <div className="bg-white rounded-xl shadow-xl p-6 w-full max-w-sm text-center">
        <img src="./I2I_logo.png" alt="" className="w-14 mx-auto mb-4 animate-pulse" />
        <h2 className="text-lg font-bold text-gray-900 mb-1">{waitingMessage}</h2>
        <p className="text-sm text-gray-600 min-h-[3.75rem]">{hintFor(seconds)}</p>

        <div className="h-2 bg-gray-100 rounded-full overflow-hidden mt-4">
          <div
            className="h-full bg-[#F20034] rounded-full transition-all duration-500"
            style={{ width: `${progress}%` }}
          />
        </div>
        <p className="text-xs text-gray-400 mt-2">{seconds}s · Please keep this page open</p>
      </div>
    </div>
  );
}
